/**
 * localStorage access for the UI language.
 *
 * A stored value means the user explicitly picked it — nothing else writes here (i18next caching
 * is off in @/i18n/config, so an OS-derived default never gets persisted).
 *
 * Values written by the old i18next auto-cache count as an explicit choice too: existing installs
 * keep the language they are already running, so the OS default only applies to fresh installs.
 */

import { LANGUAGE_STORAGE_KEY, SupportedLanguage } from "@/constants/languages";

/** @returns Stored language, or null when the user never picked one. */
export function readStoredLanguage(): string | null {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

/** Persist an explicit user choice. */
export function saveStoredLanguage(language: SupportedLanguage): void {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Ignore storage errors
  }
}

/** Drop the stored choice → back to "no preference yet". */
export function clearStoredLanguage(): void {
  try {
    localStorage.removeItem(LANGUAGE_STORAGE_KEY);
  } catch {
    // Ignore storage errors
  }
}
